import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import MicrolinkCard from '../controls/MicrolinkCard';
import InspirationForm from './InspirationForm';

@inject('userStore')
@observer
class Inspiration extends Component {
    constructor(props){
        super(props);
        this.state = {
        }
    }

    render() {
        const {inspiration_list, modalHandler, event, saveInspiration} = this.props;
        return (
          <div className="card card-outline-secondary">
              <header className="card-header">
                <h4 className="card-title card-title-bold"><i className="fa fa-lightbulb-o"></i> Inspiration Ideas</h4>
                <div className="card-header-actions">
                  <button className="btn btn-sm btn-primary" onClick={()=>modalHandler(null, InspirationForm, event)}><i className="fa fa-plus"></i> Add</button>
                </div>
              </header>
              <div className="card-body">
                <p className="lead">Give your artist inspiration ideas by sharing links such as pinterest boards or images.</p>
                {inspiration_list.map((inspiration, index)=> {
                  if (inspiration.sys_media_type_id === 3 && inspiration.url !== ''){
                    return (
                      <div className="card card-shadowed" key={index}>
                        <div className="card-body">
                          <h2><a href={inspiration.url}>{inspiration.url}</a></h2>
                        </div>
                        <footer className="card-footer flexbox">
                          <p><em>{inspiration.contents}</em></p>
                          <div className="text-right flex-grow">
                            <button className="btn btn-sm btn-danger" onClick={()=>saveInspiration(inspiration, event, 'delete')}>Delete</button>
                          </div>
                        </footer>
                      </div>
                    );
                  }
                })}
              </div>
          </div>
        );
    }
}

export default Inspiration;

// <div key={index} className="media media-single media-action-visible">
//   <MicrolinkCard url={inspiration.url} key={index}/>
//   <a className="media-action hover-danger" href="#" data-provide="tooltip" title="" data-original-title="Delete"><i className="ti-close"></i></a>
// </div>



// WEBPACK FOOTER //
// ./src/components/client/Inspiration.js